import { lazy } from 'react';
import { useSuperBundleOfferDetails } from 'src/apis/super-bundle-service/use-super-bundle-offer-details';
import type { SuperBundleServiceRequest } from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';

const AddInformationForm = lazy(() => import('./add-information-form'));

export const SetOperatorProposal = ({
  superBundleServiceRoot,
}: {
  superBundleServiceRoot: Successful<SuperBundleServiceRequest>;
}) => {
  const superBundleOfferDetails = useSuperBundleOfferDetails({
    superBundleServiceRoot,
  });

  if (!superBundleOfferDetails.response) {
    return <PageSpinner />;
  }

  return (
    <AddInformationForm superBundleOfferDetails={superBundleOfferDetails} />
  );
};
